module.exports = __webpack_public_path__ + "img/Icon_Chevron_Up.357e5a98.svg";